module.exports = __webpack_public_path__ + "img/logo_light.e5a1b352.png";